import { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
} from "@mui/material";
import { exportToPDF } from "../../utils/ExportPDFSFR";
import { exportToPDFIndividual } from "../../utils/ExportPDFSFR_Individual";
import ScappSwitch from "../../utils/ScappSwitch";

const ExportMenuSFR = ({ chartInstanceRef, invert ,dialogOpen, setDialogOpen, horizontalLinePlugin, setLoadingPDF, setProgressPDF, translate }) => {
  const t = (key, fallback) => {
    const value = typeof translate === "function" ? translate(key) : key;
    return value && value !== key ? value : fallback;
  };
  const [darkModePDF, setDarkModePDF] = useState(false);

  // ðŸ‘‡ NUEVO
  const [generalChart, setGeneralChart] = useState(false);

  const handleExport = async () => {
    try {
      setLoadingPDF(true);
      setProgressPDF(0);
      setDialogOpen(false);
      const chart = chartInstanceRef.current;

      const options = {
        darkModePDF,
        title: t('corrected_sfr', 'SFR Corregido [ % ]'),
        invert,
        horizontalLinePlugin,
        fileName: generalChart
          ? "Reporte_SFR_por_Metrica.pdf"
          : "Reporte_SFR.pdf",
        onProgress: (percent) => setProgressPDF(percent),
      };

      if (generalChart) {
        await exportToPDFIndividual(chart, options);
      } else {
        await exportToPDF(chart, options);
      }

    } finally {
      setLoadingPDF(false);
      setProgressPDF(0);
    }
  };

  return (
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        PaperProps={{
          sx: {
            bgcolor: '#0c0c0c !important', 
            color: "#e6e6e6",
            border: "0.01vw solid #e94e1a",
            borderRadius: ".4vw",
            minWidth: '15vw',
            boxShadow: 'none',
          },
        }}
        slotProps={{
          backdrop: { sx: { backgroundColor: "rgba(0, 0, 0, 0)" } },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: 700,
            letterSpacing: 0.2,
            borderBottom: "0.01vw solid #e94e1a",
            // pb: "1vh",
            bgcolor: '#0c0c0c !important', 
          }}
        >
          {t('export_options', 'Opciones de exportacion')}
        </DialogTitle>

        <DialogContent sx={{ display: "grid", gap: "1.2rem", bgcolor: '#0c0c0c !important',  }}>
          <FormControlLabel
            sx={{ ".MuiFormControlLabel-label": { color: "#cbd5e1", fontWeight: 500 }, gap: ".5vw" , marginTop:'1vh'}}
            control={
              <ScappSwitch
                isChecked={darkModePDF}
                onToggle={(e, checked) => setDarkModePDF(typeof checked === "boolean" ? checked : e.target.checked)}
                inputProps={{ "aria-label": t('dark_mode_pdf', 'Modo oscuro PDF') }}
              />
            }
            label={t('dark_mode_pdf', 'Modo oscuro PDF')}
          />

          {/* ðŸ‘‡ NUEVO: selector de grÃ¡fico general */}
          <FormControlLabel
            sx={{ ".MuiFormControlLabel-label": { color: "#cbd5e1", fontWeight: 500 }, gap: ".5vw" }}
            control={
              <ScappSwitch
                isChecked={generalChart}
                onToggle={(e, checked) => setGeneralChart(typeof checked === "boolean" ? checked : e.target.checked)}
                inputProps={{ "aria-label": t('separate_metrics', 'Separar metricas') }}
              />
            }
            label={t('separate_metrics', 'Separar metricas')}
          />
        </DialogContent>

        <DialogActions sx={{ borderTop: "1px solid #e84e0e", p: 2, gap: 1,  bgcolor: '#0c0c0c !important',  }}>
          <Button
            onClick={() => setDialogOpen(false)}
            sx={{ textTransform: "none", color: "#cbd5e1",bgcolor: "#0c0c0c !important", "&:hover": { bgcolor: "rgba(148,163,184,.08) !important" } }}
          >
            {t('cancel', 'Cancelar')}
          </Button>
          <Button variant="contained" onClick={handleExport}
            sx={{ textTransform: "none", color: "#cbd5e1",bgcolor: "#0c0c0c !important", border:'solid 0.01vw #e84e0e', "&:hover": { bgcolor: "rgba(148,163,184,.08) !important" } }}
          
          >
            {t('generate_pdf', 'Generar PDF')}
          </Button>
        </DialogActions>
      </Dialog>
  );
};

export default ExportMenuSFR;

